import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Spacing, fonts } from "../../config";
import { ptBR } from "date-fns/locale";
import { useFormFull } from "form-full";
import styled from "styled-components";
import FontStyles from "../styles/fontStyles";

export type TextInputDateMMyyyyBaseProps = {
  label?: string;
  alternativeColors?: boolean;
  inputStyle?: any;
  required?: string;
  readOnly?: boolean;
  icon?: any;
  theme?: any;
  disableError?: boolean;
  borderRadius?: any;
  variant?: "desktop" | "mobile" | "static";
  views?: Array<"year" | "month" | "day">;
  autoOk?: boolean;
  format?: string;
  minDate?: string;
  maxDate?: string;
  autoComplete?: string;
  end?: string;
  restProps?: any;
  name: string;
  color?: string;
};

const StyledDatePicker = styled(DatePicker)(({ theme, error }: any) => {
  const { palette: colors } = theme;
  return {
    ".MuiInputBase-root": {
      margin: 0,
      border: 'none',
      borderRadius: 5,
      color: colors.text.primary,
      backgroundColor: "white",
      fontFamily: fonts.medium,
      fontSize: fonts.sizes.regular,
      padding: "6px 8px 7px 8px",
      "& input": {
        padding: "6px 8px 7px 8px",
        "&::placeholder": {
          opacity: 0.8,
        },
      },
      "& fieldset": {
        border: error ? 'none' : 0,
      },
    },
  };
});

const Label = styled.p<{ $witherror?: boolean }>(({ theme, $witherror }) => {
  const { palette: colors } = theme as any;
  return {
    ...FontStyles.semibold14,
    textTransform: "uppercase",
    color: $witherror ? colors.error.main : colors.text.secondary,
    transition: ".2s",
    pointerEvents: "none",
  };
});

function InputDateMMyyyyComponent(props: TextInputDateMMyyyyBaseProps) {
  const { value, error, onChange, ref } = useFormFull.field(props);

  const {
    label,
    required,
    disableError,
    readOnly,
    minDate,
    maxDate,
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <Label $witherror={Boolean(error) ? true : undefined}>
        {label}
        {Boolean(required)}
      </Label>
      <StyledDatePicker
        minDate={minDate ? new Date(minDate) : undefined}
        maxDate={maxDate ? new Date(maxDate) : undefined}
        value={value ? value : null}
        views={["year", "month"]}
        openTo="month"
        disableFuture
        inputRef={ref}
        readOnly={readOnly}
        onChange={(date) => {
          onChange(null, date);
        }}
        slotProps={{
          textField: {
            variant: "outlined",
            fullWidth: true,
            required: Boolean(required),
            error: Boolean(error),
            helperText: disableError ? null : error ? error : " ",
            InputProps: {
              readOnly: readOnly,
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}

export default InputDateMMyyyyComponent;
